import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Home from '../views/Home.vue'
import ClientBook from '../views/ClientBook.vue'
import ClientDocs from '../views/ClientDocs.vue'
import CallLog from '../views/CallLog.vue'
import Login from '../views/Login.vue'
import SignUp from '../views/SignUp.vue'
import Onboarding from '../views/Onboarding.vue'
import Invite from '../views/Invite.vue'
import Jobs from '../views/Jobs.vue'
import JobsEnterprise from '../views/JobsEnterprise.vue'
import ClientPortal from '../views/ClientPortal.vue'
import Users from '../views/Users.vue'
import Dashboard from '../views/Dashboard.vue'
import Settings from '../views/Settings.vue'

// Dashboard sub-pages (lazy-loaded)
const DashboardOverview = () => import('../views/dashboard/DashboardOverview.vue')
const DashboardCustomers = () => import('../views/dashboard/DashboardCustomers.vue')
const DashboardMap = () => import('../views/dashboard/DashboardMap.vue')
const DashboardStaff = () => import('../views/dashboard/DashboardStaff.vue')

// Settings sub-pages (lazy-loaded)
const SettingsSmsTemplates = () => import('../views/settings/SettingsSmsTemplates.vue')
const SettingsSmsConfig = () => import('../views/settings/SettingsSmsConfig.vue')
const SettingsCompany = () => import('../views/settings/SettingsCompany.vue')
const SettingsNotifications = () => import('../views/settings/SettingsNotifications.vue')
const SettingsTests = () => import('../views/settings/SettingsTests.vue')
const SettingsRegions = () => import('../views/settings/SettingsRegions.vue')
const SettingsCustomFields = () => import('../views/settings/SettingsCustomFields.vue')
import Test from '../views/Test.vue'
import Crm from '../views/Crm.vue'
import Tracker from '../views/Tracker.vue'
import AcceptJobs from '../views/accept_jobs.vue'
import Outlook from '../views/Outlook.vue'
import Azure from '../views/azure.vue'
import Fleet from '../views/Fleet.vue'
import AiPlanner from '../views/AiPlanner.vue'
import AiAssistant from '../views/AiAssistant.vue'
import Timesheets from '../views/Timesheets.vue'
import ClientJobView from '../views/ClientJobView.vue'
import Files from '../views/Files.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/client-portal/:id',
    name: 'ClientPortal',
    component: ClientPortal
  },
  {
    path: '/callbacks/azure',
    name: 'Azure',
    component: Azure
  },

  {
    path: '/outlook',
    name: 'Outlook',
    component: Outlook
  },
  {
    path: '/accept-jobs',
    name: 'AcceptJobs',
    component: AcceptJobs
  },
  {
    path: '/test',
    name: 'Test',
    component: Test
  },
  {
    path: '/crm',
    name: 'Crm',
    component: Crm
  },
  {
    path: '/tracker',
    name: 'Tracker',
    component: Tracker,
    meta: { requiresAdminOrTeamLeader: true }
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/dashboard',
    component: Dashboard,
    children: [
      { path: '', redirect: { name: 'DashboardOverview' } },
      { path: 'overview', name: 'DashboardOverview', component: DashboardOverview },
      { path: 'customers', name: 'DashboardCustomers', component: DashboardCustomers },
      { path: 'map', name: 'DashboardMap', component: DashboardMap },
      { path: 'staff', name: 'DashboardStaff', component: DashboardStaff },
    ],
  },
  {
    path: '/settings',
    component: Settings,
    children: [
      { path: '', redirect: { name: 'SettingsSmsTemplates' } },
      { path: 'sms-templates', name: 'SettingsSmsTemplates', component: SettingsSmsTemplates },
      { path: 'sms-config', name: 'SettingsSmsConfig', component: SettingsSmsConfig },
      { path: 'company', name: 'SettingsCompany', component: SettingsCompany },
      { path: 'notifications', name: 'SettingsNotifications', component: SettingsNotifications },
      { path: 'tests', name: 'SettingsTests', component: SettingsTests },
      { path: 'regions', name: 'SettingsRegions', component: SettingsRegions },
      // Admin only — this page controls a global feature flag.
      { path: 'custom-fields', name: 'SettingsCustomFields', component: SettingsCustomFields, meta: { requiresAdmin: true } },
    ],
  },
  {
    path: '/client-book',
    name: 'ClientBook',
    component: ClientBook
  },
  {
    path: '/client-docs',
    name: 'ClientDocs',
    component: ClientDocs
  },
  {
    path: '/call-log',
    name: 'CallLog',
    component: CallLog
  },
  {
    path: '/users',
    name: 'Users',
    component: Users
  },
  {
    path: '/onboarding',
    name: 'Onboarding',
    component: Onboarding
  },
  {
    path: '/invite/:id',
    name: 'Invite',
    component: Invite
  },
  {
    path: '/jobs',
    name: 'Jobs',
    component: JobsEnterprise,
    meta: { requiresAdmin: true }
  },
  {
    path: '/jobs/legacy',
    name: 'JobsLegacy',
    component: Jobs
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: SignUp
  },
  {
    path: '/fleet',
    name: 'Fleet',
    component: Fleet
  },
  {
    path: '/ai-planner',
    name: 'AiPlanner',
    component: AiPlanner
  },
  {
    path: '/ai',
    name: 'AiAssistant',
    component: AiAssistant
  },
  {
    path: '/timesheets',
    name: 'Timesheets',
    component: Timesheets
  },
  {
    path: '/job/:token',
    name: 'ClientJobView',
    component: ClientJobView
  },
  {
    path: '/tests',
    name: 'Tests',
    component: Files
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAdmin) {
    const user = store.state.currentUser
    if (!user || user.role !== 'admin') {
      next({ name: 'Home' })
      return
    }
  }
  if (to.meta.requiresAdminOrTeamLeader) {
    const user = store.state.currentUser
    if (!user || (user.role !== 'admin' && user.isTeamLeader !== true)) {
      next({ name: 'Home' })
      return
    }
  }
  next()
})

export default router
